import { post } from "./baseService";

export async function addFaq(data) {
  const response = await post(`faqs`, data, true);
  return response;
}
